export const defaultValue = {
  setModal: () => undefined,
  closeAllModals: () => undefined,
  closeModal: () => undefined,
};
